function computeDropdownSelectedIndex(value, dropdownOptions) {
  if (value === null) return -1;
  const deltaFromSelected = dropdownOptions.map((option) => Math.abs(option.value - value));
  const minDelta = Math.min(...deltaFromSelected);
  return deltaFromSelected.indexOf(minDelta);
}
export {
  computeDropdownSelectedIndex
};
//# sourceMappingURL=computeDropdownSelectedIndex.js.map
